import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d668659e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "col-12 p-col-6 p-md-6" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Doanh thu năm trước", -1))
const _hoisted_7 = { class: "col-12 p-col-6 p-md-6" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian tìm kiếm: ", -1))
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tổng doanh thu", -1))
const _hoisted_13 = { class: "col-12 p-col-12 p-md-12" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, "Biểu đồ thống kê doanh thu chi tiết trong 2 năm", -1))
const _hoisted_16 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_17 = { id: "loading" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang tải dữ liệu vui lòng chờ ...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_lv = _resolveComponent("lv")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thống kê doanh thu" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Panel, { header: "Doanh thu cùng kỳ" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", null, _toDisplayString(_ctx.doanhThuCungKy.thoiGianNamTruoc), 1),
                _createVNode(_component_InputNumber, {
                  id: "namtruoc",
                  modelValue: _ctx.doanhThuCungKy.namTruoc,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doanhThuCungKy.namTruoc) = $event)),
                  mode: "decimal",
                  minFractionDigits: 2,
                  maxFractionDigits: 5,
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", null, _toDisplayString(_ctx.doanhThuCungKy.thoiGianNamNay), 1),
                _createVNode(_component_InputNumber, {
                  id: "namnay",
                  modelValue: _ctx.doanhThuCungKy.namNay,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doanhThuCungKy.namNay) = $event)),
                  mode: "decimal",
                  minFractionDigits: 2,
                  maxFractionDigits: 5,
                  readonly: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputNumber, {
                  id: "doanhthucanam",
                  modelValue: _ctx.doanhThuCungKy.doanhThuCaNam,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doanhThuCungKy.doanhThuCaNam) = $event)),
                  mode: "decimal",
                  minFractionDigits: 2,
                  maxFractionDigits: 5,
                  readonly: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Panel, { header: "Doanh thu trong ngày" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Calendar, {
                  id: "date",
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event)),
                  selectionMode: "range",
                  dateFormat: "dd/mm/yy",
                  showButtonBar: true,
                  showIcon: true,
                  manualInput: false,
                  monthNavigator: true,
                  yearNavigator: true,
                  yearRange: "2000:2100",
                  onDateSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectCalendar())),
                  onClearClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearCalendar()))
                }, null, 8, ["modelValue"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doanhThu, (dt) => {
                return (_openBlock(), _createBlock(_component_lv, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", null, _toDisplayString(dt.tenphongban), 1),
                      _createVNode(_component_InputNumber, {
                        id: "money",
                        modelValue: dt.tien,
                        "onUpdate:modelValue": ($event: any) => ((dt.tien) = $event),
                        mode: "decimal",
                        minFractionDigits: 2,
                        maxFractionDigits: 5
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 256)),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_InputNumber, {
                  id: "total",
                  modelValue: _ctx.tongTien,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tongTien) = $event)),
                  mode: "decimal",
                  minFractionDigits: 2,
                  maxFractionDigits: 5
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Chart, {
              type: "bar",
              data: _ctx.totalData,
              options: _ctx.basicOptions
            }, null, 8, ["data", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Dialog, {
            header: "Đang xử lý thông tin",
            visible: _ctx.loadingBar,
            "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.loadingBar) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_ProgressBar, {
                  mode: "indeterminate",
                  style: {"height":".3em"}
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_ConfirmDialog)
        ])
      ])
    ]),
    _: 1
  }))
}